// Kotak "Aksi" di rincian WO (Titipan auditor 27 Okt 2026, jejak E1 Langkah 43): sesudah klik Mulai di tahap Layout,
// tombol "Mulai Produksi" hilang (memang digantikan) dan kotaknya KOSONG tanpa penjelasan. Fungsi ini menyusun
// kalimat "apa yang dilakukan berikutnya" untuk keadaan tanpa tombol — atau null bila tombolnya memang tampil.

const SELESAI = ["COMPLETED", "SKIPPED"];

export function penjelasanAksiWo({ status, stages = [], label = (k) => k, bisaAjukan = false, bisaSetujui = false,
  bisaMulai = false, bisaTahap = false } = {}) {
  if (status === "DRAFT") {
    return bisaAjukan ? null : "WO masih draf. Admin Produksi atau Owner memeriksanya lalu mengajukan ke Kepala Cabang.";
  }
  if (status === "PENDING_KEPALA_CABANG") {
    return bisaSetujui ? null : "Menunggu Kepala Cabang menyetujui dan mengunci WO ini.";
  }
  if (status === "LOCKED") {
    return bisaMulai ? null : "WO sudah dikunci. Produksi dimulai Admin Produksi dari tahap pertama.";
  }
  if (status === "IN_PROGRESS") {
    const kini = (stages || []).find((s) => !SELESAI.includes(s.status));
    if (!kini) return "Semua tahap sudah selesai. WO tertutup otomatis sesudah tahap terakhir dicatat.";
    const nama = label(kini.stage_code);
    const serah = " Jumlah barang yang pindah antar tahap dicatat di menu Produksi › Serah Terima Tahap.";
    if (kini.status === "IN_PROGRESS") {
      return bisaTahap
        ? `Produksi berjalan — tahap ${nama} sedang dikerjakan. Bila sudah rampung, klik Selesaikan di tahap itu pada Timeline Produksi di bawah, lalu Mulai tahap berikutnya.${serah}`
        : `Produksi berjalan — tahap ${nama} sedang dikerjakan.`;
    }
    return bisaTahap
      ? `Produksi berjalan. Tahap berikutnya: ${nama} — klik Mulai di tahap itu pada Timeline Produksi di bawah.${serah}`
      : `Produksi berjalan. Tahap berikutnya: ${nama}.`;
  }
  return null;
}
